module.exports = __webpack_public_path__ + "static/media/addCompoundIcon.33cb98b9.svg";